module.exports = __webpack_public_path__ + "static/media/flossyfresh-2.9bd80b92.jpg";